import { animate } from 'animejs';

export function useMediaFadeIn(options = {}) {
	const { duration = 600, easing = 'easeOutQuad' } = options;

	// 显示动画
	const show = target => {
		if (!target) return;

		animate(target, {
			opacity: [0, 1],
			duration,
			easing
		});
	};

	return {
		show
	};
}
